import styled from 'styled-components';

export const TaProgressBarWrapDiv = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  flex-wrap:wrap;
  padding-right:${props.theme.spacing.base};
  padding-left:${props.theme.spacing.large};
  padding-top: ${props.theme.spacing.xsmall};
  padding-bottom: ${props.theme.spacing.xsmall};
  width:75%;

  `,
);

export const TaProgressBarInnerDiv = styled.div(
  props => `
  display:flex;
  flex-direction:column;
  flex-wrap:wrap;
  width:100%;
  padding-top:${props.theme.spacing.small};

  `,
);

export const TaProgressBarContentDiv = styled.div(
  props => `
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  width: 100%;
  padding-top:${props.theme.spacing.small};
  padding-bottom:${props.theme.spacing.small};
  `,
);

export const TaTextDiv = styled.div(
  props => `
  display:flex;
  width:25%;
  flex-wrap:wrap;
  padding-right:${props.theme.spacing.small};
  font-size:${props.theme.font.custom(15)};
  `,
);

export const BarWrapDiv = styled.div(
  props => `
  display:flex;
  width:58%;
  flex-wrap:wrap;
  margin-right:${props.theme.spacing.base};
  margin-top:${props.theme.spacing.custom(7)};
  height:0.8rem;
  border-radius: ${props.theme.misc.borderRadius.large};
  background-color: ${props.theme.colors.goBrandBlue.light};
  overflow: hidden;
  `,
);

export const BarWrapInnerDiv = styled.div(
  props => `
  width: 100%;
  `,
);

export const InnerRatingBarWrapDiv = styled.div(
  props => `
  display:flex;
  width: ${props.width}%;
  flex-wrap:wrap;
  height:0.8rem;
  border-radius: ${props.theme.misc.borderRadius.large};
  background-color: ${props.theme.colors.goGreen.base};
  overflow: hidden;
  `,
);

export const RatingNumberDiv = styled.div(
  props => `
  display:flex;
  width:12%;
  flex-wrap:wrap;
  font-size:${props.theme.font.custom(16)};
  `,
);
